// extracted by mini-css-extract-plugin
module.exports = {"logos":"logoGrid-module--logos--rM42E"};